import React from "react";
import { SvgProps } from "./Form";

export const ChatNotification = (props: SvgProps) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.03144 16H6.78735L7.95402 11.3333H5.5431C5.31011 11.3332 5.08036 11.2786 4.87223 11.1739C4.66409 11.0692 4.48334 10.9172 4.34441 10.7302C4.20549 10.5431 4.11224 10.3262 4.07212 10.0967C4.032 9.86714 4.04612 9.63142 4.11335 9.40833L6.35394 2H11.8764L10.1264 6.66667H12.4731C12.7401 6.66684 13.0021 6.73935 13.2312 6.8765C13.4602 7.01365 13.6479 7.21032 13.7741 7.44558C13.9004 7.68085 13.9605 7.94593 13.9482 8.21265C13.9358 8.47937 13.8514 8.73775 13.7039 8.96033L9.03144 16ZM8.28185 14.8333H8.40552L12.7315 8.31517C12.7625 8.26842 12.7803 8.21415 12.7829 8.15813C12.7855 8.1021 12.7729 8.04642 12.7464 7.99699C12.7199 7.94757 12.6804 7.90625 12.6323 7.87743C12.5842 7.84861 12.5292 7.83337 12.4731 7.83333H8.44285L10.1929 3.16667H7.2196L5.22985 9.74433C5.215 9.79325 5.21181 9.84496 5.22055 9.89533C5.22928 9.94569 5.24969 9.99331 5.28014 10.0344C5.3106 10.0754 5.35024 10.1088 5.39591 10.1318C5.44157 10.1547 5.49198 10.1667 5.5431 10.1667H9.45144L8.28185 14.8333Z"
      fill="currentColor"
    />
  </svg>
);
